import React from 'react';
import ReactDOM from 'react-dom/client';
import { APP_BRAND } from '@/config/brand';
import '@brand-palette';
import App from './App';
import './styles/index.css';

if (APP_BRAND === 'hid') {
  document.documentElement.dataset.brand = 'hid';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
